module.exports = __webpack_public_path__ + "img/lb-2048.ed8ae57c.svg";